import {request, serviceUrl} from "@/utils/request";

export function listByCategory(category) {
  return request({
    url: serviceUrl.notificationService + '/notice-template/listByCategory',
    params: {category}
  })
}

export function saveSetting(data) {
  return request({
    method: 'post',
    url: serviceUrl.notificationService + '/notice-template-setting/saveSetting',
    data: data
  })
}

export function updateSetting(data) {
  return request({
    method: 'post',
    url: serviceUrl.notificationService + '/notice-template-setting/updateSetting',
    data: data
  })
}
